// extracted by mini-css-extract-plugin
export var standaloneTable = "_i3-0";
export var standaloneTableWithBodyFill = "_i3-1";
export var withExtraHeader = "_i3-2";